require('./angular-locale_fr-fr');
module.exports = 'ngLocale';



//////////////////
// WEBPACK FOOTER
// ./~/angular-i18n/fr-fr.js
// module id = 173
// module chunks = 1